/**
 * Created by or_p on 10/1/2016.
 */
import _ from 'lodash';

export default class KeyboardSequenceRecorder {
  constructor(callback, onEnterKeyDown) {
    window.addEventListener('keypress', this.onKeypress);
    window.addEventListener('keydown', this.onKeyDown);
    this.repeat = 0;
    this.value = '';
    this.callback = callback;
    this.onEnterKeyDown = onEnterKeyDown;
  }

  onKeypress = (event) => {
    const input = String.fromCharCode(event.keyCode || event.which);
    if (this.lastInput === input) {
      this.repeat++;
    } else {
      this.repeat = 0;
      this.value += input;
    }
    this.lastInput = input;
    this.debouncedClearValue();
    if (this.callback) {
      this.callback(this.value, this.repeat);
      if (_.isEmpty(this.value)) { // in case the callback had cleared ths input since there is no match
        this.value += input;
        this.callback(this.value, this.repeat);
      }
    }
  };

  onKeyDown = event => {
    switch (event.keyCode) {
      case 8:
      case 46:
        this.clearValue();
        break;
      case 13:
        if (this.onEnterKeyDown) {
          this.onEnterKeyDown();
        }
        break;
      default:
        break;
    }
  };

  clearValue = () => {
    this.value = '';
    this.repeat = 0;
  };

  debouncedClearValue = _.debounce(this.clearValue, 2000);

  destroy = () => {
    window.removeEventListener('keypress', this.onKeypress);
    window.removeEventListener('keydown', this.onKeyDown);
  };
}
